import { render, staticRenderFns } from "./AccountAddressDetails.vue?vue&type=template&id=0dcae0ba&"
import script from "./AccountAddressDetails.vue?vue&type=script&lang=js&"
export * from "./AccountAddressDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports